















import { defineComponent } from '@nuxtjs/composition-api';
import { focus } from '@shared/ui/utilities/directives';

export default defineComponent({
  name: 'BaseChevron',
  directives: {
    focus,
  },
  data(...args): any {
    return args;
  },
});
